import { render, staticRenderFns } from "./positon.vue?vue&type=template&id=6cd75250"
import script from "./positon.vue?vue&type=script&lang=js"
export * from "./positon.vue?vue&type=script&lang=js"
import style0 from "./positon.vue?vue&type=style&index=0&id=6cd75250&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports